﻿
export default class Start {
    activeIndex = -1;

    constructor() {
        this.setupTeaser();
        this.setBulletProgress(0);
        this.setBulletListener();
    }

    setupTeaser() {
        const scrollContainer = document.querySelector(".teaser-section");
        this.bullets = Array.from(document.querySelectorAll(".teaser-section-bullet"));

        if(scrollContainer) {
            const teasers = Array.from(scrollContainer.querySelectorAll(".startpageteaser"));
            
            teasers.forEach((teaser, i) => {
                teaser.id = 'startpageteaser-' + i;           
            });

            scrollContainer.addEventListener('scroll', () => {
                const position = scrollContainer.scrollLeft;
                const totalScrollWidth = scrollContainer.scrollWidth;
                const scrollContainerWidth = scrollContainer.getBoundingClientRect().width;
                const progress = position / (totalScrollWidth - scrollContainerWidth);
                
                this.setBulletProgress(progress);
            })
        }
    }

    setBulletProgress(progress) {
        const bullets = this.bullets;
        const len = bullets.length;
        let nextIndex = Math.round(len * (progress-(0.2)));
        nextIndex = nextIndex < 0 ? 0 : nextIndex > len-1 ? len-1 : nextIndex;

        if(nextIndex !== this.activeIndex) {
            const activeElement = this.bullets[this.activeIndex];

            if(activeElement) {
                activeElement.classList.remove("teaser-section-bullet--active");
            }
        }

        const nextElement = this.bullets[nextIndex];

        if(nextElement) {
            nextElement.classList.add("teaser-section-bullet--active");
        }

        this.activeIndex = nextIndex;

        bullets.forEach((bullet, i) => {
            bullet.setAttribute('data-teaser-id', 'startpageteaser-' + i);
        })
    }

    setBulletListener() {
        const bullets = this.bullets;

        bullets.forEach(bullet => {
            bullet.addEventListener('click', e => {
                const teaserId = e.target.getAttribute("data-teaser-id");
                this.scrollToTeaser(teaserId);
            })
        })
    }

    scrollToTeaser(teaserId) {
        const teaser = document.getElementById(teaserId);
        teaser.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
}
